import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { dateTimeFormats, registerLoadComponentLanguageAsync, missing, loadLanguageAsync } from '@rrze/vue-smi18n'

Vue.use(VueI18n)

registerLoadComponentLanguageAsync(VueI18n)

export const i18n = new VueI18n({
  dateTimeFormats,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  missing
})

export const asyncLanguageLoad = (lang, compName = null) => loadLanguageAsync(i18n, lang)

export default i18n
